export enum Types {
  Membership = 'Membership',
  Contact = 'Contact',
  Company = 'Company',
  Product = 'Product',
  Invoice = 'Invoice',
  Address = 'Address',
  User = 'User',
  Template = 'Template',
  RecipientList = 'RecipientList',
  Scheduler = 'Scheduler',
  CalendarEvent = 'CalendarEvent',
  ETF = 'Etf',
  Stock = 'Stock',
  Index = 'Index',
  IndexSeries = 'IndexSerie',
  Nav = 'Nav',
  DividendGross = 'DividendGross',
  HistoryLtv = 'HistoryLtv',
  HistoryKpi = 'HistoryKpi',
  HistoryAward = 'HistoryAward',
  AllocationSector = 'AllocationSector',
  HistoryAllocationCountry = 'HistoryAllocationCountry',
  HistoryRecalc = 'HistoryRecalc'
}
